import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import {
  dateFormaterWithMonth,
  dateFormatWithYear,
} from "../../../utils/commonfunction";
import "./columnchart.scss";
import { pageLocale } from "../../../utils/locale";
import { getParams } from "../../../utils/helpers";

const InvertedColumnChart = ({
  graphOptions,
  historyData,
  forPDF,
  hidePlotLines = false,
}) => {
  const dataFinal = historyData?.data || historyData;
  const timeRange = [];
  const leftData = [];
  const rightData = [];
  let maxRange = 0;
  dataFinal?.forEach((element) => {
    const time = element.timeStamp || element.timestamp;
    const value = Number(element.value.toFixed(1));
    if (Math.abs(value) > maxRange) maxRange = Math.abs(value);
    forPDF ? timeRange.unshift(time) : timeRange.push(time);
    forPDF ? leftData.unshift(value) : leftData.push(value);
    forPDF ? rightData.unshift(value * -1) : rightData.push(value * -1);
  });
  const { locale } = getParams();
  const widthHandler = () => {
    if (locale === "ja") {
      return { width: 205, height: 170 };
    } else return { width: 205, height: 150 };
  };
  const resolution = forPDF
    ? widthHandler()
    : { width: window.innerWidth < 770 ? window.innerWidth - 50 : 400 };
  const {
    l_shoulder_label,
    r_shoulder_label,
    shoulder_balance,
    r_hip_label,
    l_hip_label,
  } = pageLocale("newreport");

  const leftlabelHandler = () => {
    if (graphOptions?.name === shoulder_balance) {
      return l_shoulder_label;
    } else {
      return l_hip_label;
    }
  };
  const rightlabelHandler = () => {
    if (graphOptions?.name === shoulder_balance) {
      return r_shoulder_label;
    } else {
      return r_hip_label;
    }
  };
  const datalabelHandler = (val) => {
    if (forPDF) {
      return `<div style="color: #434343; background-color: #f2f2f2; font-size: 10px;padding: 0px">${val}</div>`;
    }
    if (!val) {
      return `<div style="color: #434343; background-color: #f2f2f2; font-size: 14px;padding: 3px 5px">${val}</div>`;
    }
  };
  const options = {
    chart: {
      type: "column",
      borderRadius: 8,
      ...resolution,
      marginTop: forPDF && 10,
      spacingBottom: 0,
    },
    title: {
      text: forPDF ? null : graphOptions?.title,
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      enabled: true,
      useHTML: true,
      formatter: function () {
        const opt = this.point.options;
        const val = opt.y;
        return (
          val &&
          `<div style="direction:ltr"><strong style="font-size: 14px;margin: 0;padding: 0;font-weight: 300">${dateFormatWithYear(
            this?.point?.category,
          )}</strong><br/><p style="text-align:center; font-weight: 600; font-size: 14px; margin: 0;padding: 0">${Number(
            val.toFixed(2),
          )} °</p></div>`
        );
      },
    },
    legend: {
      layout: "horizontal",
      verticalAlign: "top",
      align: "right",
      // enabled: true,
      enabled: !forPDF && true,
      y: 20,
    },
    xAxis: {
      lineWidth: 0, // removing x axis line
      categories: timeRange,
      labels: {
        formatter: function () {
          return dateFormaterWithMonth(this?.value);
        },
        rotation: 0,
        style: {
          fontSize: forPDF ? "0.52em" : "0.8em",
          fontWeight: "600",
        },
      },
    },
    yAxis: {
      gridLineWidth: 1, //removing y axis grid lines
      lineWidth: 1, // adding lines for yaxis axis
      gridLineColor: "#B8B8B8",
      title: {
        text: "",
      },
      plotLines: hidePlotLines
        ? []
        : [
            {
              value: 0, // Value where the line will appear
              color: "#000", // Color of the line
              width: 1, // Width of the line
              zIndex: 100, // Higher zIndex ensures it appears above the grid lines
            },
          ],
      labels: {
        padding: 0,
        margin: 0,
        x: forPDF ? -5 : -22,
        useHTML: true,
        formatter: function () {
          return this.value + "<sup>" + "&deg;" + "</sup>";
        },
        style: {
          fontSize: forPDF ? "8px" : "13px",
          padding: "0px", // Or any CSS property that helps control spacing
          fontWeight: "600",
        },
      },
      max: maxRange * 1.1,
      min: maxRange * -1.1,
      plotBands: hidePlotLines
        ? []
        : [
            {
              from: -2,
              to: 2,
              color: "rgba(180, 234, 175, 0.37)",
            },
          ],
    },
    series: [
      {
        name: leftlabelHandler(),
        data: leftData,
        color: "#8EB2F3",
        pointWidth: forPDF ? 17 : 17, // for adjusting single value this will be best way option
        // pointPadding: 0.2,
        // enableMouseTracking: false, when cursor moves particular value it looks like fadding
      },
      {
        name: rightlabelHandler(),
        data: rightData,
        color: "#3769B4",
        pointWidth: forPDF ? 17 : 17,
      },
    ],
    plotOptions: {
      series: {
        //for disable fading series on marker / legend hover
        states: {
          inactive: {
            opacity: 1,
          },
        },
        events: {
          legendItemClick: function () {
            return false;
          },
        },
      },
      column: {
        borderRadius: 0,
        grouping: false,
        shadow: false, // for make it single line
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          useHTML: true,
          align: "center",
          // verticalAlign: "bottom",
          crop: false,
          // overflow: "allow",
          // alignTo: "plotEdges",
          // inside: true,
          // x: -5,
          y: 0,
          fontSize: "8px",
          formatter: function () {
            return datalabelHandler(this?.point?.options?.y);
          },
        },
      },
    },
  };

  return (
    <div className="column-chart-wrapper">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default InvertedColumnChart;
